<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
        <path d="M1 6.5L4.5 9.5L10.5 1.5" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>